<template>
  <div>
    <h3 class="md-title">
      <md-icon>trip_origin</md-icon>
      {{ $route.name }}
    </h3>
    <div class="md-layout">
      <!-- 목록 시작 -->
      <md-card>
        <md-card-header md-alignment="space-between">
          <h4 class="title">
            <md-icon>list</md-icon>
            사용자 목록
          </h4>
        </md-card-header>
        <md-card-content>
          <div class="table-header-info">
            <div>총 {{ pagination.total }} 건의 검색결과가 있습니다.</div>
            <md-card-actions md-alignment="right">
              <md-button class="md-info md-sm" @click="newUser" v-auth-btn="[5,3]">
                <md-icon>person_add</md-icon>
                신규 등록
              </md-button>
            </md-card-actions>
          </div>
          <grid ref="userGrid"
                :data="gridProps.data"
                :columns="gridProps.columns"
                :options="gridProps.options"
                :theme="gridProps.theme"
                :rowHeaders="gridProps.rowHeaders"
                :columnOptions="gridProps.columnOptions"
                :language="gridProps.lang"
                @dblclick="onDblClickExecutive"
                @response="response"
          ></grid>
        </md-card-content>
      </md-card>
      <md-card v-show="isUserConnectHis">
        <md-card-header md-alignment="space-between">
          <h4 class="title">
            <md-icon>list</md-icon>
            사용자 접속 이력
          </h4>
        </md-card-header>
        <md-card-content>
          <md-table :value="userConnectHisList" class="paginated-table table-striped table-hover text-align-center h-scroll h200">
            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-table-cell md-label="일련번호">{{ item.seqNo }}</md-table-cell>
              <md-table-cell md-label="접속일시">{{ item.lastConnectDate }}</md-table-cell>
              <md-table-cell md-label="접속IP">{{ item.connectIp }}</md-table-cell>
              <md-table-cell md-label="로그인 실패횟수">{{ item.failCount }}</md-table-cell>
            </md-table-row>
          </md-table>
        </md-card-content>
      </md-card>
    </div>

    <!--사용자 입력/수정 팝업 -->
    <modal v-if="isShowUserModal" class="search-friend-modal">
      <template slot="header">
        <h4 class="modal-title">사용자 등록(변경)</h4>
        <md-button class="md-simple md-just-icon md-round modal-default-button" @click="() => {this.isShowUserModal = false}">
          <md-icon>clear</md-icon>
        </md-button>
      </template>
      <template slot="body">
        <div class="md-layout">
          <table class="flex-table">
            <tr>
              <th>사용자 ID</th>
              <td v-if="isEdit"><input type="text" v-model="userData.userNo" disabled></td>
              <td v-if="!isEdit"><input type="text" v-model="userData.userNo"></td>
              <th>비밀번호</th>
              <td v-if="isEdit"><input type="text" v-model="userData.userPasswd" disabled></td>
              <td v-if="!isEdit"><input type="text" v-model="userData.userPasswd"></td>
              <th>사용자명</th>
              <td><input type="text" v-model="userData.userNm"></td>
              <th>부서명</th>
              <td><input type="text" v-model="userData.partNm"></td>
            </tr>
            <tr>
              <th>직위</th>
              <td><input type="text" v-model="userData.levelNm"></td>
              <th>E-mail</th>
              <td><input type="text" v-model="userData.email"></td>
              <th>입사일</th>
              <td>
                <div class="inline-flex">
                  <div class="inline-flex">
                    <input type="text" v-model="userData.joinDate" v-mask="'####-##-##'">
                  </div>
                </div>
              </td>
              <th>퇴사일</th>
              <td>
                <div class="inline-flex">
                  <input type="text" v-model="userData.retireDate" v-mask="'####-##-##'">
                </div>
              </td>
            </tr>
            <tr>
              <th>전화번호</th>
              <td>
                <div class="inline-flex">
                  <input type="text" v-model="userData.tel" v-mask="'############'">
                </div>
              </td>
              <th>직원구분</th>
              <td>
                <select v-model="userData.userStatus">
                  <option v-for="item in userStatusItems" :key="item.value" :label="item.text" :value="item.value"/>
                </select>
              </td>
              <th>사용권한</th>
              <td>
                <select v-model="userData.userRight">
                  <option v-for="item in userRightItems" :key="item.value" :label="item.text" :value="item.value"/>
                </select>
              </td>
              <th>계정사용</th>
              <td>
                <select v-model="userData.agentGb">
                  <option v-for="item in agentGbItems" :key="item.value" :label="item.text" :value="item.value"/>
                </select>
              </td>
            </tr>
            <tr>
              <th>로그인실패횟수</th>
              <td>
                <input type="text" v-model="userData.failCount">
              </td>
              <th>최종접속일</th>
              <td>
                <div class="inline-flex">
                  <input type="text" v-model="userData.lastConnectDate" readonly>
                </div>
              </td>
              <th>비밀번호변경일</th>
              <td>
                <input type="text" v-model="userData.changePwdDate" readonly>
              </td>
              <th>비밀번호경과일</th>
              <td>
                <input type="text" v-model="userData.pwdChangeDayCnt" readonly>
              </td>
            </tr>
          </table>
        </div>
      </template>
      <template slot="footer">
        <md-button class="md-info md-sm" @click="saveUser" v-auth-btn="[5,3]">저장</md-button>
        <md-button class="md-default md-sm" @click="() => {this.isShowUserModal = false; this.isEdit = false;}">취소</md-button>
      </template>
    </modal>
  </div>
</template>

<script>
import {Modal} from "@/components";
import URL_CONST from "@/kuaa/kuaa-url-const";
import kuaaApi from "@/kuaa/kuaa-api";
import kuaaFnc from "@/kuaa/kuaa-comm-func";

import { Grid } from '@toast-ui/vue-grid';
import 'tui-grid/dist/tui-grid.css';
import 'tui-pagination/dist/tui-pagination.css';
import Swal from "sweetalert2";

export default {
  components: {
    Modal,
    grid: Grid
  },
  created() {
    this.initGrid();
  },
  mounted() {
    this.hInitGrid();
  },

  data(){
    return {
      isShowUserModal: false,
      isEdit: true,
      roleGrpList: [],
      pagination: {
        page: 1,
        perPage: 20,
        currentPage: 1,
        total: 0
      },
      hPagination: {
        page: 1,
        perPage: 20,
        currentPage: 1,
        total: 0
      },
      userData: {
        editYn: "Y",
        userNo: "",
        userNm: "",
        partNm: "",
        levelNm: "",
        tel: "",
        innerNo: "",
        joinDate: "",
        email: "",
        retireDate: "",
        userStatus: "1",
        userRight: "1",
        agentGb: "1",
        userPasswd: "",
        failCount: 0,
        changePwdDate: null
      },
      userStatusItems: [
        {text: '정직원', value: '1'},
        {text: '임시직', value: '2'}
      ],
      userRightItems: [],
      agentGbItems: [
        {text: '사용', value: '1'},
        {text: '정지', value: '2'}
      ],
      isUserConnectHis: false,
      userConnectHisList: null,
      connectHisUserNo: null
    };
  },
  methods: {
    newUser(){
      this.userData = {
        userNo: "",
        userNm: "",
        partNm: "",
        levelNm: "",
        tel: "",
        innerNo: "",
        joinDate: "",
        email: "",
        retireDate: "2099-12-31",
        userStatus: "1",
        userRight: "1",
        agentGb: "1",
        failCount: 0,
        changePwdDate: null,
        userPasswd: "1qaz2wsx!"
      };
      this.isEdit = false;
      this.isShowUserModal = true;
    },
    initGrid() {
      kuaaFnc.fncMenuGrpList(res => {
        this.userRightItems = res.data.data.contents;
      });
      
      this.gridProps = kuaaFnc.setGridInit(URL_CONST.GET_USER_LIST, true, this.pagination);
      this.gridProps['el'] = this.$refs.userGrid;
      this.gridProps['columns']= [
        {header: '사용자ID', name: 'userNo', align:'center'},
        {header: '사용자명', name: 'userNm', align:'center'},
        {header: '부서', name: 'partNm', align:'center'},
        {header: '직위', name: 'levelNm', align:'center'},
        {header: '전화번호', name: 'tel', align:'center'},
        {header: '내선번호', name: 'innerNo', align:'center'},
        {header: '이메일', name: 'email', align:'center'},
        {header: '입사일', name: 'joinDate', align:'center'},    //editor:{type:DatePicker, options:{format:'yyyy-MM-dd'}}},
        {header: '퇴사일', name: 'retireDate', align:'center'},
        {header: '직원구분', name: 'userStatus',
          formatter: 'listItemText',
          align:'center',
          editor: {
            type: 'select',
            options: {
              listItems: this.userStatusItems
            }
          }
        },
        {header: '권한그룹', name: 'userRightNm', align:"center"},
        {header: '계정사용', name: 'agentGb',
          formatter: 'listItemText',
          align:'center',
          editor: {
            type: 'select',
            options: {
              listItems: this.agentGbItems
            }
          }
        },
        {header: '최종접속일시', name: 'lastConnectDate', align:"center", width:125,
          formatter(value) {
            return `<span style="color:#0091d5; cursor:pointer">${value.value}</span>`;
          }
        },
        {header: '접속IP', name: 'connectIp', align:"center"},
        {header: '비밀번호변경일', name: 'changePwdDate', align:"center"},
        {header: '로그인실패횟수', name: 'failCount', hidden:true},
        {header: '비밀번호경과일', name: 'pwdChangeDayCnt', hidden:true},
        {header: '사용권한', name: 'userRight', hidden:true}

      ];
      this.gridProps['options'].bodyHeight = 400;
    },

    response(e){
      if (this.instance == null) {
        this.instance = e.instance;
      }
      let res = JSON.parse(e.xhr.response);

      if(res.result){
        this.pagination.total = res.data.pagination.totalCount;
        if(this.pagination.total == 0){
            let modalOptions = kuaaFnc.getSwalModaloptions({
              html: "접근 권한이 없는 사용자 입니다."
            });
            Swal.fire(modalOptions);
        }

      }else{
        kuaaFnc.showSwal("사용자 관리", res.resultMessage);
      }
    },

    onDblClickExecutive(e) {
      if(e.instance.getRow(e.rowKey) != null) {
        let rowData = e.instance.getRow(e.rowKey);

        if(e.columnName === "lastConnectDate"){
          if(rowData.lastConnectDate) {
            this.isUserConnectHis = true;
            this.searchConnectHis(rowData.userNo);
          }else{
            this.isUserConnectHis = false;
            this.userConnectHisList = null;
          }
        }else{
          if(this.connectHisUserNo !== rowData.userNo){
            this.isUserConnectHis = false;
            this.userConnectHisList = null;
          }
          this.isEdit = true;
          this.isShowUserModal = true;
          this.userData = rowData;
        }
      }
    },
    
    saveUser(){
      let reg = /^[a-zA-Z0-9]{4,8}$/;

      if(!reg.test(this.userData.userNo)){
        this.isShowUserModal = false;
        let modalOptions = kuaaFnc.getSwalModaloptions({
          html: "아이디 오류입니다.<br>[문자로 시작, 최소 4 ~ 8자]"
        });
        Swal.fire(modalOptions).then(() => this.isShowUserModal = true);
        return false;
      }
      this.userData.retireDate = kuaaFnc.cleanDateFormatter(this.userData.retireDate);
      this.userData.joinDate = kuaaFnc.cleanDateFormatter(this.userData.joinDate);
      this.isShowUserModal = false;
       kuaaApi.sendServer(
          URL_CONST.SAVE_USER,
          this.userData,
          "post",
          response => {
            if(response.data.success){
              kuaaFnc.showSwal("사용자 관리");
              this.$refs.userGrid.invoke("readData", this.$refs.userGrid.invoke("getPagination")._currentPage, null);

            }else{

            }
          }
      );
    },

    searchConnectHis(userNo) {
      this.connectHisUserNo = userNo;
      this.isUserConnectHis = true;
      kuaaApi.sendServer(
          URL_CONST.GET_USER_CONNECT_LIST,
          {userNo:userNo},
          "post",
          response => {
        this.userConnectHisList = response.data.data.contents;
      });
    },
  }
};
</script>

<style scoped>
tr.md-table-row{
  cursor: pointer;
}
</style>